import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "../pages/Dashboard";
import Home from "../pages/Home";
import AppLayout from "../layouts/Layout";
import OrganisationPage from "../pages/OrganisationPage";
import RegisterRequestPage from "../pages/RegisterRequestPage";
import WeekTemplatePage from "../pages/WeekTemplatePage";
import WeekPlanPage from "../pages/WeekPlanPage";
import ScheduleViewerPage from "../pages/ScheduleViewerPage";
import SummaryPage from "../pages/SummaryPage";
import TimeTrackingPage from "../pages/WorkStatusAppPage";
import WorkStatusAppPage from "../pages/WorkStatusAppPage";
import PricesPage from "../pages/PricesPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Impressum from "../pages/Impressum";
import AccountSettings from "../pages/AccountSettings";

export default function RoutesComponent() {
  return (
    
        <AppLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Dashboard" element={<ProtectedRoute><Dashboard></Dashboard></ProtectedRoute>} />
        <Route path="/week-plan" element={<ProtectedRoute><WeekPlanPage></WeekPlanPage></ProtectedRoute>} />
        <Route path="/employees" element={<ProtectedRoute><OrganisationPage></OrganisationPage></ProtectedRoute>} />
        <Route path="/registration" element={<RegisterRequestPage></RegisterRequestPage>} />
        <Route path="/settings/week-template" element={<ProtectedRoute><WeekTemplatePage></WeekTemplatePage></ProtectedRoute>} />"
        <Route path="/viewer" element={<ProtectedRoute><ScheduleViewerPage></ScheduleViewerPage></ProtectedRoute>} />
        <Route path="/summary" element={<ProtectedRoute><SummaryPage></SummaryPage></ProtectedRoute>} />
        <Route path="/work-status" element={<ProtectedRoute><WorkStatusAppPage></WorkStatusAppPage></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountSettings></AccountSettings></ProtectedRoute>} />
        <Route path="/prices" element={<PricesPage />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
        <Route path="/impressum" element={<Impressum />} />

      </Routes>
      </AppLayout>
    
  );
}